"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var material_1 = require("@angular/material");
var NotificationDetailsPopupComponent = /** @class */ (function () {
    function NotificationDetailsPopupComponent(dialogRef, data) {
        this.dialogRef = dialogRef;
        this.data = data;
        this._pageSize = 1;
        this._currentPage = 0;
        this._deliveryStatuses = data.deliveryStatuses || [];
        this._emails = data.emails || [];
        this._currentDeliveryStatus = this._deliveryStatuses.length === 0 ? null : this._deliveryStatuses[0];
    }
    Object.defineProperty(NotificationDetailsPopupComponent.prototype, "deliveryStatuses", {
        get: function () {
            return this._deliveryStatuses;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NotificationDetailsPopupComponent.prototype, "emails", {
        get: function () {
            return this._emails;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NotificationDetailsPopupComponent.prototype, "currentDeliveryStatus", {
        get: function () {
            return this._currentDeliveryStatus;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NotificationDetailsPopupComponent.prototype, "pageSize", {
        get: function () {
            return this._pageSize;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NotificationDetailsPopupComponent.prototype, "currentPage", {
        get: function () {
            return this._currentPage;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NotificationDetailsPopupComponent.prototype, "totalItemsCount", {
        get: function () {
            return this._totalItemsCount;
        },
        enumerable: true,
        configurable: true
    });
    NotificationDetailsPopupComponent.getConfig = function (deliveryStatuses, emails) {
        var dialogConfig = new material_1.MatDialogConfig();
        dialogConfig.width = '800px';
        dialogConfig.height = 'auto';
        dialogConfig.autoFocus = false;
        dialogConfig.data = {
            deliveryStatuses: deliveryStatuses,
            emails: emails
        };
        return dialogConfig;
    };
    NotificationDetailsPopupComponent.prototype.ngOnInit = function () {
        this._totalItemsCount = this.deliveryStatuses.length;
    };
    NotificationDetailsPopupComponent.prototype.changeCurrentPage = function (newPage) {
        this._currentPage = newPage;
        this._currentDeliveryStatus = this._deliveryStatuses.length === 0 ? null : this._deliveryStatuses[newPage];
    };
    NotificationDetailsPopupComponent.prototype.close = function () {
        this.dialogRef.close(false);
    };
    NotificationDetailsPopupComponent = __decorate([
        core_1.Component({
            selector: 'ejustice-notification-details',
            template: require('./notification-details-popup.component.html'),
            styles: [require('./notification-details-popup.component.css')]
        }),
        __param(1, core_1.Inject(material_1.MAT_DIALOG_DATA)),
        __metadata("design:paramtypes", [material_1.MatDialogRef, Object])
    ], NotificationDetailsPopupComponent);
    return NotificationDetailsPopupComponent;
}());
exports.NotificationDetailsPopupComponent = NotificationDetailsPopupComponent;
//# sourceMappingURL=notification-details-popup.component.js.map